export default "__VITE_ASSET__Bwng7bFq__"